module.exports = __webpack_public_path__ + "media/images/pic/rodzice-evy-i-milana-fc36802aa3b46e1a423f6064852045e1.jpeg";